import {
  redoMarketCountryIdFormat,
  redoMarketIdFormat,
} from "@redotech/redo-model/ids";
import * as z from "zod/v4";
import { pricingInclusionMode } from "./pricing-inclusion-mode";
import { marketWithCountriesOutput } from "./redo-market";

const countryCode = z
  .string()
  .regex(/^[A-Z]{2}$/, "Must be ISO 3166-1 alpha-2 uppercase");

const countryInput = z.object({
  /** Existing publish target to keep; omit for net-new countries, which get
   * their Shopify market/catalog/price list provisioned on save. */
  id: redoMarketCountryIdFormat.schema.optional(),
  destinationCountryCode: countryCode,
});

/**
 * Upsert a market's policy fields plus its full set of country rows.
 * Omit `marketId` to create. Country rows missing from the input list are
 * soft-deleted. Markup rate is a decimal-string multiplier ("1.000000" = no
 * markup).
 */
export const upsertRedoMarket = {
  name: "upsertRedoMarket" as const,
  input: z.object({
    marketId: redoMarketIdFormat.schema.optional(),
    /** Merchant-set display name; pass null to clear and fall back to the
     * auto-generated label, omit to leave unchanged. */
    name: z.string().nullable().optional(),
    enabled: z.boolean().optional(),
    inclusionMode: pricingInclusionMode.optional(),
    markupRate: z.string().optional(),
    countries: z.array(countryInput),
  }),
  output: marketWithCountriesOutput.extend({
    /** Count of the account's Shopify variants with no HS code. These won't be
     * published to this market until they're classified. Optional so older
     * backends can omit it without breaking the client. */
    variantsMissingHsCode: z.number().optional(),
  }),
};
